import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'equine-ui-nx-bt-micro-deposit-verification',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule
  ],
  templateUrl: './bt-micro-deposit-verification.component.html',
  styleUrl: './bt-micro-deposit-verification.component.scss',
})
export class BtMicroDepositVerificationComponent implements OnInit {
  @Output() submitMicroDeposit = new EventEmitter<number[]>()

  private fb = inject(FormBuilder);
  public form!: FormGroup;
  public readonly data = inject<{bankName: string, last4: string}>(MAT_DIALOG_DATA);
  public loading = false;

  ngOnInit(): void {
    this.initForm();
  }

  initForm() { 
    this.form = this.fb.group({
      firstDeposit: [null, Validators.compose([Validators.required, Validators.min(1), Validators.max(99)])],
      secondDeposit: [null, Validators.compose([Validators.required, Validators.min(1), Validators.max(99)])]
    });
  }

  submit() {
    const data = this.form.value;
    this.submitMicroDeposit.emit([parseInt(data.firstDeposit, 10), parseInt(data.secondDeposit, 10)]);
  }

}
